import {
    ADJUSTMENTS_REASONS_FETCH,
    ADJUSTMENTS_REASONS_FETCH_ALL,
    ADJUSTMENTS_REASONS_IS_FETCING,
    ADJUSTMENT_REASONS_FILTER,
    ADJUSTMENT_REASONS_EDIT,
    UPDATE_ADJUSTMENT_REASONS_STATUS
} from 'constants/adjustmentsReasons'

export default function adjustmentsReducer(state = {
    listAll: [],
    list: [],
    pageable: {
        sort: {
            'adjustmentId': false,
            'usdAmount': 'asc',
            'ibId': false,
            'status': false,
            'creationTime': false,
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case ADJUSTMENTS_REASONS_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case ADJUSTMENTS_REASONS_FETCH_ALL:
            return {
                ...state,
                listAll: action.payload,
            }
        case ADJUSTMENT_REASONS_EDIT:
            return {
                ...state,
            }
        case ADJUSTMENTS_REASONS_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
						}
				case UPDATE_ADJUSTMENT_REASONS_STATUS:
						state.list.find((item, i) => item.adjustmentId === action.payload.adjustmentId).status = action.payload.status
						return {
							...state,
							list: [...state.list]
						}
        case ADJUSTMENT_REASONS_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/adjustmentsReasons.js